'use es6';

import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIHeader from 'UIComponents/layout/UIHeader';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIList from 'UIComponents/list/UIList';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIDropdownDivider from 'UIComponents/dropdown/UIDropdownDivider';
import { getHasVideoIntegrationScope } from 'FileManagerCore/selectors/Auth';
import ToggleVideoFeatures from 'FileManagerCore/components/modals/ToggleVideoFeatures';
import { Tabs } from '../Constants';
import AddFolderButton from './AddFolderButton';
import UploadFilesButton from './UploadFilesButton';
import DashboardHeaderAlerts from './DashboardHeaderAlerts';
import AcademyVideoLink, { ACADEMY_VIDEO_KEYS } from './AcademyVideoLink';
import { getCurrentTab } from '../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DISABLED_TABS = [Tabs.STOCK_IMAGES];
const areButtonsDisabled = (location, hasAccess) => {
  const currentTab = getCurrentTab(location);
  return DISABLED_TABS.includes(currentTab) || !hasAccess;
};
const DashboardHeader = ({
  currentFolder,
  objects,
  location,
  hasAccess
}) => {
  const hasVideoIntegrationScope = useSelector(getHasVideoIntegrationScope);
  const renderActionButtons = () => {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UploadFilesButton, {
        currentFolder: currentFolder,
        disabled: areButtonsDisabled(location, hasAccess),
        disabledTooltip: hasAccess !== false && I18n.text('FileManagerDashboard.uploadFilesButton.shutterStockDisabled'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "FileManagerDashboard.actions.uploadFiles"
        })
      }, "upload-files"), /*#__PURE__*/_jsx(AddFolderButton, {
        objects: objects,
        currentFolder: currentFolder,
        disabled: areButtonsDisabled(location, hasAccess),
        disabledTooltip: hasAccess !== false && I18n.text('FileManagerDashboard.addFolderButton.shutterStockDisabled')
      }, "add-folder")]
    });
  };
  const renderTitleControls = () => {
    if (!hasVideoIntegrationScope) {
      return null;
    }
    return /*#__PURE__*/_jsx(UIDropdown, {
      buttonUse: "transparent",
      buttonText: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "insertVideo",
          size: "small",
          className: "m-right-2"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "FileManagerCore.academyVideos.dropdownLabel"
        })]
      }),
      placement: "bottom right",
      "data-test-id": "header-hubspot-video-dropdown",
      children: /*#__PURE__*/_jsxs(UIList, {
        children: [Object.keys(ACADEMY_VIDEO_KEYS).map(videoKey => /*#__PURE__*/_jsx(AcademyVideoLink, {
          videoKey: videoKey,
          use: "dropdown"
        }, videoKey)), /*#__PURE__*/_jsx(UIDropdownDivider, {}), /*#__PURE__*/_jsx(ToggleVideoFeatures, {
          use: "dropdown"
        })]
      })
    });
  };
  return /*#__PURE__*/_jsx(UIHeader, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `FileManagerDashboard.app.filesTitle`
    }),
    titleControls: renderTitleControls(),
    alert: /*#__PURE__*/_jsx(DashboardHeaderAlerts, {
      location: location
    }),
    children: renderActionButtons()
  });
};
export default withRouter(DashboardHeader);